import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../../Utils/theme";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import { Link } from "react-router-dom";
import DentalPlanModal from "../../../components/common/Modal/DentalPlanModal";
import { GetClientsDentalPlanDetails } from "../../../api/User/Hub/dentalPlansetupApi";
import moment from "moment";
import Loader from "../../../components/common/Loader";
import NoDataMassage from "../../../components/common/NoDataMassage";
import toastFile from "../../../Service/ToastFile";
import DetailsHeader from "../../../components/common/Hub/DetailsHeader";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";

const DentalPlanSetup = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [dentalData, setDentalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [updateData, setUpdateData] = useState({});
  const [witchAction, setWitchAction] = useState("add");
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    {
      title: "Carrier",
      field: "Carrier",
    },
    {
      title: "Contract Start",
      field: "CDentalPlanContractStart",
      render: (rowData) => moment(rowData.CDentalPlanContractStart).format("MM-DD-yyyy"),
    },
    {
      title: "Contract End",
      field: "CDentalPlanContractEnd",
      render: (rowData) => moment(rowData.CDentalPlanContractEnd).format("MM-DD-yyyy"),
    },
    {
      title: "Funding Arrangement",
      field: "FundingName",
    },
    {
      title: "Plan Name",
      field: "CDentalPlanName",
    },
    {
      title: "Plan Type",
      field: "CDentalPlanType",
    },
    {
      title: "Tier Type",
      field: "CDentalPlanTierType",
    },
  ];

  useEffect(() => {
    if (!modalShow) {
      setWitchAction("add");
    }
  }, [modalShow]);

  useEffect(() => {
      if (responseMessage === "rejectedRegion") {
        toastFile("Region Rejected");
      } else if (responseMessage === "error") {
        toastFile("failed to save")
      } else if (responseMessage !== "") {
        toastFile(responseMessage, 'success')
      }
    getDentalPlanData();
    setResponseMessage("");
  }, [responseMessage, client]);

  const getDentalPlanData = () => {
    if (client !== null) {
      setIsLoading(true);
      GetClientsDentalPlanDetails(client?.clientID, user?.UD_id)
        .then((res) => {
          if(res?.status === 200 || res?.status === 204){
          setDentalData(res.data);
          setIsLoading(false);
          }
        })
        .catch((err) => setIsLoading(false));
    }
  };

  return (
    <>
      {modalShow && <DentalPlanModal
        show={modalShow}
        onHide={() => {
          setUpdateData({});
          setModalShow(false);
        }}
        witchAction={witchAction}
        user={user}
        client={client}
        updateData={updateData}
        setResponseMessage={setResponseMessage}
        getData={getDentalPlanData}
      />}
      <DetailsHeader setModalShow={setModalShow} setWitchAction={setWitchAction}/>
      <div className="mb-4" style={Fontstyling.heading}>
        Dental Plan Details:
      </div>
      <CustomMaterialTable
        isDelete={false}
        isExport={false}
        column={column}
        data={dentalData}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setUpdateData}
        setShowModal={setModalShow}
        isLoading={isLoading}
      />
      {/* <Table
        responsive
        bordered
        // size="sm"
        className="m-0"
        style={{ fontSize: "12px" }}
      >
        <thead
          style={{
            backgroundColor: theme.SECONDARY_CLASSIC_DARK,
            color: theme.SECONDARY_EGGSHELL_WHITE,
            ...tablestyle.tableheading,
          }}
        >
          <tr>
            <th>Carrier</th>
            <th>Contract Start</th>
            <th>Contract End</th>
            <th>Funding Arrangement</th>
            <th>Plan Name</th>
            <th>Plan Type</th>
            <th>Tier Type</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody style={tablestyle.tabledata}>
          {dentalData.length && !isLoading
            ? dentalData.map((item, index) => (
                <tr>
                  <td>{item.Carrier}</td>
                  <td>
                    {moment(item.CDentalPlanContractStart).format("MM-DD-yyyy")}
                  </td>
                  <td>
                    {moment(item.CDentalPlanContractEnd).format("MM-DD-yyyy")}
                  </td>
                  <td>{item.FundingName}</td>
                  <td>{item.CDentalPlanName}</td>
                  <td>{item.CDentalPlanType}</td>
                  <td>{item.CDentalPlanTierType}</td>
                  <td className="d-flex align-items-center justify-content-center">
                    <img
                      src={editIcon}
                      width="11"
                      className="py-1 cursor-pointer"
                      alt="edit icon"
                      onClick={() => {
                        setWitchAction("update");
                        setModalShow(true);
                        setUpdateData(item);
                      }}
                    />
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </Table> */}
      {/* {isLoading ? (
        <Loader />
      ) : dentalData.length === 0 ? (
        <NoDataMassage massage="No record" />
      ) : null} */}
      <div className="d-md-flex d-block align-items-center gap-3 mt-3">
        <Link
          className="text-nowrap"
          style={{ ...Fontstyling.savebutton, textDecoration: "none" }}
          to={"/HUBExperience/visionplansetup"}
        >
          Save & Continue
        </Link>
        {/* <button style={Fontstyling.cancelbutton}>Cancel</button> */}
        <div className="mt-md-0 mt-3" style={Fontstyling.secondaryparagraph}>
          To edit pre-populated company information, please make changes in
          BenefitPoint and return to Infused Analytics
        </div>
      </div>
    </>
  );
};

export default DentalPlanSetup;
